/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransactionDto } from '../../models/transaction-dto';

export interface UserControllerGetTransactions$Params {
  createdAfter?: string;
  includeUnconfirmed?: boolean;
}

export function userControllerGetTransactions(http: HttpClient, rootUrl: string, params?: UserControllerGetTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TransactionDto>>> {
  const rb = new RequestBuilder(rootUrl, userControllerGetTransactions.PATH, 'get');
  if (params) {
    rb.query('createdAfter', params.createdAfter, {});
    rb.query('includeUnconfirmed', params.includeUnconfirmed, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TransactionDto>>;
    })
  );
}

userControllerGetTransactions.PATH = '/user/me/transaction';
